import React, { useState } from 'react'
import List from './List'
import Add from './Add'
import DetailsMain from './Details/Main'
import TargetMain from './Targets/Main'

export default function Main({ pageViewHandler, admin }) {
    const [tab, setTab] = useState("list")
    const [editData, setEditData] = useState({})

    const handleTabchange = (type, data) => {
        setEditData(data)
        setTab(type)
    }
    return (
        <>
            {tab == "list" ? <List handleTabchange={handleTabchange} pageViewHandler={pageViewHandler} /> : ""}
            {tab == "add" ? <Add handleTabchange={handleTabchange} pageViewHandler={pageViewHandler} EditData={editData} /> : ""}
            {tab == "DetailsMain" ? <DetailsMain handleTabchange={handleTabchange}  EditData={editData} /> : ""}
            {tab == "targets" ? <TargetMain handleTabchange={handleTabchange}  ListData={editData} /> : ""}
        </>
    )
}
